module.exports = __webpack_public_path__ + "img/form_mobile.12f7344.jpg";